import { render, staticRenderFns } from "./ActivityRegistCancel.vue?vue&type=template&id=10dc7776&"
import script from "./ActivityRegistCancel.vue?vue&type=script&lang=js&"
export * from "./ActivityRegistCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports